import { TextInput } from '@app/components';
import React from 'react';
import { StyledForms } from '@app/components/styled/form/Form';
import { FormSection } from '@app/components/styled/form/FormSection';
import { ShopSelect } from '@app/components/form/selects/features/ShopSelect';
import { FieldWithLabel } from '@app/components/styled/form/Label';
import { Toggle } from '@app/components/form/Toggle';
import { PasswordInput } from '@app/components/form/PasswordInput';
import { RoleSelect } from '@app/components/form/selects/features/RoleSelect';

export const UserForm = () => {
  return (
    <StyledForms.Form>

      <FormSection.Section>
        <FormSection.Title>Informations générales</FormSection.Title>
        <FormSection.Content>

          <TextInput
            name="firstname"
            label="Prénom"
            autoCapitalize="none" />

          <TextInput
            name="lastname"
            label="Nom"
            autoCapitalize="none" />

          <TextInput
            name="email"
            label="Email"
            autoCapitalize="none"
            autoComplete='off'
            keyboardType="email-address" />

          <TextInput
            name="phone"
            label="Téléphone"
            keyboardType="phone-pad"
            autoComplete='off'
            autoCapitalize="none" />

        </FormSection.Content>
      </FormSection.Section>

      <FormSection.Section>
        <FormSection.Title>Informations avancées</FormSection.Title>
        <FormSection.Content>

          <ShopSelect
            name="shops"
            label="Restaurants"
            isMultiple />

          <RoleSelect
            name="roles"
            label="Rôles"
            isMultiple />

          <PasswordInput
            name="code"
            label="Code de déverrouillage caisse"
            keyboardType='numeric'
            maxLength={4}
            autoComplete='off' />

          <FieldWithLabel label="Compte utilisateur actif">
            <Toggle
              name="isDeleted"
              options={[
                { title: "Oui", value: false },
                { title: "Non", value: true },
              ]} />
          </FieldWithLabel>

        </FormSection.Content>
      </FormSection.Section>

    </StyledForms.Form>
  );
};
